<div
  class="am-status-banner animate__animated animate__fadeInUp"
  [ngClass]="'am-status-banner--' + state"
  role="alert"
  aria-live="assertive">
  <span class="am-status-banner__icon-wrap">
    <img class="am-status-banner__icon" alt="" [src]="resolvedIcon" />
  </span>
  <span class="am-status-banner__text">{{ messageKey | translate }}</span>
  @if (buttonText) {
    <button type="button" class="am-status-banner__btn" (click)="buttonClick.emit()">
      {{ buttonText | translate }}
    </button>
  }
</div>
